module.exports = __webpack_public_path__ + "static/media/navbarlogo.afb5e11d.png";